<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                Link Alternate Media
            </template>

            <div class="row align-items-center">
                <div class="col-lg-12 order-lg-1 order-2">
                    <b-form-group
                        class="mt-3"
                        label="Select Alternate Media Language"
                    >
                        <language-multiselect
                            v-model="selected_language"
                            :options="alternateLanguageOptions"
                            :multiple="false"
                            @add="addLanguage"
                            @remove="removeLanguage"
                        />
                        <b-form-invalid-feedback :state="!selected_language ? false : null">
                            Language is required before being able to select alternate media
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                        class="mt-3"
                        label="Select Alternate Media"
                    >
                        <div v-if="alternate_media_options_loading">
                            <b-spinner label="Options Loading...">Options Loading...</b-spinner>
                        </div>
                        <multiselect
                            v-else
                            :disabled="!selected_language"
                            v-model="new_language_media"
                            :options="filteredAlternateMediaOptions"
                            label="id"
                            :custom-label="formattedLabel"
                            track-by="id"
                        >
                            <template
                                v-for="slotName in ['option', 'singleLabel']"
                                #[slotName]="{ option }"
                            >
                                <span :key="slotName" class="d-flex align-items-center">
                                    <flag :iso="getFlagIso(option.language)" /> {{ option.id }} - {{ option.title }}
                                </span>
                            </template>
                        </multiselect>
                    </b-form-group>
                </div>
            </div>

            <template #modal-footer>
                <div v-if="!adding_media">
                    <b-button
                        variant="primary"
                        @click="linkAlternateMedia"
                        :disabled="validating()"
                    >
                        Link Alternate Media
                    </b-button>
                </div>
                <div v-else>
                    <b-spinner small label="Linking..."></b-spinner>
                    - Linking Alternate Media 
                </div>
                <b-button
                    variant="light"
                    @click="cancel"
                    :disabled="adding_media"
                >
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

import LanguageMultiselect from '@/components/LanguageMultiselect'

import languages from '@/common/languages'

export default {
    data: () => ({
        new_language_media: null,
        selected_language: null,
        languages: languages,
        adding_media: false
    }),
    props: [
        'alternate_media_options',
        'alternate_media_options_loading',
        'media_to_link',
        'media_group',
        'value'
    ],
    components: {
        LanguageMultiselect
    },
    computed: {
        ...mapState({
        }),
        modal_id () {
            let modal_id = 'add-alternate-media-modal'
            return modal_id
        },
        alternateLanguageOptions() {
            return this.languages.filter(lang => lang.language !== this.media_to_link.language);
        },
        filteredAlternateMediaOptions() {
            const media_group_ids = this.media_group.map(media => media.id);
            if (!this.selected_language) {
                return this.alternate_media_options
            }
            if (this.alternate_media_options.length > 0) {
                return this.alternate_media_options.filter(media => {

                    let language_match = media.language === this.selected_language.language;
                    let not_in_media_group = !_.includes(media_group_ids, media.id);

                    return language_match && not_in_media_group
                })
            }
            return [];
        }
    },
    watch: {
        'media_to_link.id': {
            handler(value) {
                // mark to remove once we have more than two languages
                this.setStartingSelectedLanguage();
            }
        },
    },
    methods: {
        validating(){
            if (!this.new_language_media) {
                return true;
            }
            const { id } = this.new_language_media;

            return !(this.selected_language && id);
        },
        addLanguage(new_language){
            this.selected_language = new_language;
        },
        removeLanguage(){
            this.selected_language = null;
            this.new_language_media = null;
        },
        cancel (event) {
            event.preventDefault()
            this.new_language_media = null
            this.hide()
        },
        hide () {
            this.$emit('hideAddAlternate')
        },
        hidden () {
            this.$emit('hideAddAlternate')
        },
        formattedLabel(option) {
            return `${option.id} - ${option.title}`;
        },
        getFlagIso(language) {
            const languageObject = this.languages.find(lang => lang.language === language);
            return languageObject ? languageObject.flag_iso : null;
        },
        findMediaByLanguage(mediaArray, language) {
            return mediaArray.find(media => media.language === language);
        },
        getLanguageLabel(language) {
            const languageObject = this.languages.find(lang => lang.language === language);
            return languageObject ? languageObject.label : null;
        },
        linkMediaToGroup() {
            this.axios.post('/api/media/link_media_to_group/'+this.media_to_link.id+'/'+this.new_language_media.id+'/'+this.new_language_media.group_id)
                .then(response => {
                    if(!response){
                        this.$bvToast.toast('An error has ocurred', {
                            title: 'Error',
                            variant: 'danger',
                            solid: false,
                            autoHideDelay: 3000,
                            appendToast: true
                        })
                    }
                    else{
                        this.$bvToast.toast('Media was successfully linked', {
                            title: 'Success',
                            variant: 'success',
                            solid: false,
                            autoHideDelay: 3000,
                            appendToast: true
                        })
                    }
                    this.$emit('alternateAdded');
                    this.new_language_media = null
                    this.hide()
                    
                })
        },
        linkAlternateMedia() {
            const linkedMedia = this.findMediaByLanguage(this.media_group, this.new_language_media.language);
            if (linkedMedia) {
                let message = `
                    <h4>Selected Media already has ${this.getLanguageLabel(this.new_language_media.language)} Media linked</h4>
                    </br>
                    <p><strong>${this.media_to_link.id} - ${this.media_to_link.title} (${this.media_to_link.language})</strong> 
                    is already linked to <strong>${linkedMedia.id} - ${linkedMedia.title} (${linkedMedia.language})</strong>. Do you want to continue and replace this media with the 
                    new selected ${this.getLanguageLabel(this.new_language_media.language)} language media <strong>${this.new_language_media.id} - ${this.new_language_media.title}</strong>?</p>
                `
                this.$swal({
                    html: message,
                    showCancelButton: true,
                    confirmButtonText: 'Link to new Media',
                    confirmButtonColor: '#27AE60',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {               
                        this.linkMediaToGroup()
                    }
                })
            } else {
                this.linkMediaToGroup()
            }
        },
        setStartingSelectedLanguage() {
            // This function just sets the selected language based on the media_to_link language and is only needed while we have two languages (en & es)
            // once more languages are added we don't need to do this check, as you will want select beteween multiple languages in the select language dropdown
            if (this.media_to_link.language === 'es') {
                this.selected_language = {
                    language: 'en',
                    label: 'English',
                    flag_iso: 'us'
            }
            } else if (this.media_to_link.language === 'en') {
                this.selected_language = {
                    language: 'es',
                    label: 'Spanish',
                    flag_iso: 'es'
                }
            }
        },
        
    },
    mounted () {
        // mark to remove once we have more than two languages
        this.setStartingSelectedLanguage();
        
        
    },
    
}

</script>
